var exports = {
  "i": "xaee3c4fa--92b446--wrapper",
  "f": "xaee3c4fa--92b446--form-wrapper",
};

module.exports = exports;
